import { Loadable } from 'utils/components';
import { SCREEN_DETAIL_PATH as path } from 'constants/paths';

export default {
  path,
  component: Loadable({
    loader: () => import(/* webpackChunkName: 'Screen' */ './components/ScreenPage')
  })
};
